import { WEB_PUSH_MODAL_NAME } from './webPush.vars'
import { webPuchState } from './webPush.state'
import { webPushModalService } from './webPushModal.service'

export function useWebPushModal() {
  /**
   * Open webpush modal
   * Only if supports WebPush and does not ask permission
   */
  function webPushModalOpen(): boolean {
    if (
      !webPuchState.init ||
      webPuchState.token ||
      webPuchState.permissionAsked
    )
      return false
    webPushModalService.open()
    return true
  }

  return {
    name: WEB_PUSH_MODAL_NAME,
    webPushModalService,
    webPushModalOpen,
  }
}
